import { request } from "../client"

export type AdminDemoResetCapabilityState =
  | "ready"
  | "not_found"
  | "inactive"
  | "admin_organization"
  | "not_free_trial"
  | "checkout_required"
  | "never_successfully_reset"
  | "missing_admin_credentials"
  | "missing_employee_credentials"
  | "active_job"

export type AdminDemoResetCapability = {
  organization_id: string
  eligible: boolean
  state: AdminDemoResetCapabilityState
  active_job_id: string | null
}

export type AdminDemoResetCapabilitiesResponse = {
  items: AdminDemoResetCapability[]
}

export type AdminDemoResetBatchDisposition =
  | "queued"
  | "idempotent_replay"
  | "already_active"
  | "rejected"

export type AdminDemoResetBatchItem = {
  organization_id: string
  disposition: AdminDemoResetBatchDisposition
  job_id: string | null
  reason_code: AdminDemoResetCapabilityState | null
}

export type AdminDemoResetBatchResponse = {
  results: AdminDemoResetBatchItem[]
}

export const getAdminDemoResetCapabilities = (
  options: { signal?: AbortSignal } = {},
): Promise<AdminDemoResetCapabilitiesResponse> =>
  request<AdminDemoResetCapabilitiesResponse>("/demo-organization-reset-jobs/capabilities", {
    method: "GET",
    signal: options.signal,
  })

export const enqueueAdminDemoResetBatch = (
  organizationIds: string[],
  options: { idempotencyKey: string; signal?: AbortSignal },
): Promise<AdminDemoResetBatchResponse> =>
  request<AdminDemoResetBatchResponse>("/demo-organization-reset-jobs/batch", {
    method: "POST",
    headers: { "Idempotency-Key": options.idempotencyKey },
    body: JSON.stringify({
      organization_ids: organizationIds,
      confirmation: "DEMO RESET",
    }),
    signal: options.signal,
  })
